import React from 'react';
import DashboardLayout from '../components/layouts/DashboardLayout';
import PrincipalSubmissions from './principal/tabs/PrincipalSubmissions';

function PrincipalDashboard({ user, onLogout, apiBase }) {
  const handleTabChange = (tabId) => {
    if (tabId === 'approvals') {
      // submissions tab is shown
    }
  };

  return (
    <DashboardLayout 
      user={user} 
      onLogout={onLogout} 
      userRole="approver"
      onTabChange={handleTabChange}
    >
      <PrincipalSubmissions apiBase={apiBase} />
    </DashboardLayout>
  );
}

export default PrincipalDashboard;
